/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import * as _ from 'lodash';
import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { Constants, Partner } from '../global/constants';

/**
 * Service for interacting with 3rd parties supporting list/field mapping capabilities
 *
 * This service manages a local cache to make sure we only request lists or fields once
 */
@Injectable()
export class PartnerService {

  private partnerCache: any = {};

  constructor(private http: HttpClient,
    private constants: Constants) {
    this.constants.partners.forEach(p => {
      this.partnerCache[p.name] = {
        lists: [],
        fields: []
      };
    });
  }

  /**
   * Get list of partners
   */
  getPartners(): Observable<Array<Partner>> {
    return this.http
      .get(
      `/api/v1/partner`
      )
      .map((response: any) => {
        let ret: Array<Partner> = [];

        response.forEach(p => {
          let partnerName = this.constants.partners.find(cp => cp.name == p );
          if (!_.isNil(partnerName)) {
            ret.push(partnerName);
          }
        });
        return ret;
      });
  }

  getLists(partner: string, useCache: string = 'true'): Observable<any> {


    return this.http
      .get(
      `/api/v1/partner/${partner}/lists?cache=${useCache}`
      );
  }

  getFields(partner: string): Observable<any> {
    if (this.partnerCache[partner].fields.length > 0) {
      return Observable.of(this.partnerCache[partner].fields);
    }

    return this.http
      .get(
      `/api/v1/partner/${partner}/fields`
      )
      .map((response: any) => {
        this.partnerCache[partner].fields = response || [];
        return this.partnerCache[partner].fields;
      });
  }

  clearListCache(partner: string) {
    this.partnerCache[partner].lists = [];
  }

  clearFieldCache(partner: string) {
    this.partnerCache[partner].fields = [];
  }
}



// WEBPACK FOOTER //
// ./client/app/services/partner.service.ts